<template>
  <div class="chatbot-template">
    <a-row :gutter="12" class="row-content">
      <a-col class="gutter-row" :span="sizeGrid">
        <section-board
          :visibleDrawer="visibleDrawer"
          :currentChannel="currentChannel"
          @onOpenDrawer="handleOpenDrawer"
          @create-node="handleCreateNode"
          @preview="handlePreviewImage"
        />
      </a-col>

      <transition name="slide-fade" v-on:after-leave="afterLeave">
        <a-col class="gutter-row" :span="8" v-if="visibleDrawer && treeNodes.length !== 0">
          <DrawerSettings
            :settings="nodeSelected"
            :chatbotId="chatbotId"
            :currentChannel="currentChannel"
            :optionsConnectorApi="optionsConnectorApi"
            @replaceItem="onReplaceItem"
            :channels="chatbot.channels_companies ? chatbot.channels_companies : []"
            @update="updated_at = new Date()"
            @isChanges="setIsChanges"
            @handleCloseDrawer="handleCloseDrawer"
            @create-node="handleCreateNode"
            @update-nodes="fetchNodes"
            @onChangeSettings="handleChangeSettings"
            @preview="handlePreviewImage"
          />
        </a-col>
      </transition>
    </a-row>
  </div>

  <ImagePreviewModal v-model:open="imageModal.open" :image-url="imageModal.url" />
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import { DefaultNodeBodies, ChildNodeType, BotActions } from "@/app/chatbots/utils/enums";
import { updateNode } from "@/app/chatbots/services";

import DrawerSettings from "@/app/chatbots/components/organisms/DrawerSettings.vue";
import SectionBoard from "@/app/chatbots/components/sections/SectionBoard.vue";
import ImagePreviewModal from "@/app/chatbots/components/modals/ImagePreviewModal.vue";
import { connectorServices } from "@/app/ivr/bot/services/ConnectorServices";
import { onMounted, ref } from "vue";

export default {
  name: "ChatbotTemplate",
  components: {
    DrawerSettings,
    SectionBoard,
    ImagePreviewModal,
  },
  props: {
    currentChannel: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    visibleDrawer: false,
    sizeGrid: 24,
    modalUpdateChatbot: {
      visible: false,
      bodyStyle: { padding: 0 },
    },
    settings: null,
    loadingForm: false,
    replaceItem: null,
    updated_at: new Date(),
    isChanges: false,
    chatbot: {},
    updatedName: null,
    imageModal: {
      open: false,
      url: "",
    },
  }),
  setup() {
    const optionsConnectorApi = ref([]);

    const fetchConnectorList = async () => {
      try {
        // loading.value = true;
        const response = await connectorServices.getList();
        optionsConnectorApi.value = response.map((el) => ({ ...el, value: el.id, label: el.name }));
      } catch (error) {
        console.log(error);
      } finally {
        // loading.value = false;
      }
    };

    onMounted(() => {
      fetchConnectorList();
    });

    return {
      optionsConnectorApi,
    }
  },
  provide() {
    return {
      handleCreateNode: this.handleCreateNode,
    };
  },
  computed: {
    ...mapGetters([
      "listChatbots",
      "listNodesChatbot",
      "company",
      "changes",
      "profile",
      "nodeSelected",
      "selectedNodeId",
    ]),

    chatbotId() {
      return this.$route.params.id;
    },
    treeNodes() {
      return this.$store.getters["getChatbotNodes"];
    },
  },
  methods: {
    ...mapActions([
      "generateTreeNodes",
      "resetTreeNodes",
      "updatedChatbot",
      "getChatbot",
      "getAssignedLines",
      "getNodes",
    ]),
    ...mapMutations(["RESET_CHATBOT_MODULE"]),

    async loadData() {
      this.chatbot = await this.getChatbot(this.$route.params.id);
      this.updated_at = new Date(this.chatbot.updated_at);
    },
    loadTreeNodes() {
      this.generateTreeNodes(this.$route.params.id);
    },
    afterLeave() {
      this.sizeGrid = 24;
    },
    handleOpenDrawer(settings) {
      this.settings = settings;
      this.visibleDrawer = true;
      this.sizeGrid = 16;
    },
    handleCloseDrawer() {
      this.visibleDrawer = false;
    },
    handleShowModalUpdateChatbot() {
      this.modalUpdateChatbot.visible = true;
    },
    onReplaceItem(response) {
      this.replaceItem = response;
    },
    setIsChanges(isChanges) {
      this.isChanges = isChanges;
    },
    handleCloseSettings() {
      this.modalUpdateChatbot.visible = false;
    },
    afterCloseEdit() {
      this.$refs.formEditChatbot.handleReset();
    },
    handleChangeSettings(settings) {
      this.settings = settings;
    },
    handleSuccessUpdated(chatbot) {
      this.chatbot = chatbot;
      this.modalUpdateChatbot.visible = false;
    },
    handlePreviewImage(imageUrl) {
      console.log(imageUrl);
      this.imageModal.open = true;
      this.imageModal.url = imageUrl;
    },
    async handleCreateNode({ nodeType, parentNodeId = null, previousAction = null, newBody }) {
      try {
        console.log(nodeType, 'nodeType');
        const newNodeBody = { ...DefaultNodeBodies[nodeType] };
        console.log(DefaultNodeBodies, 'DefaultNodeBodies');
        console.log(newNodeBody, 'newNodeBody');
        if (parentNodeId) newNodeBody.node = parentNodeId;

        console.log(newBody, 'newBody');

        const data = newBody || newNodeBody;

        console.log(data, 'data');

        const createdNode = await this.$store.dispatch("createNode", {
          chatbotId: this.$route.params.id,
          body: newBody || newNodeBody,
        });

        const childNodeType = ChildNodeType[nodeType];

        console.log(childNodeType, 'childNodeType');
        console.log(previousAction, 'previousAction');
        if (childNodeType) {
          // const childNodeBody = {
          //   ...DefaultNodeBodies[childNodeType],
          //   node: createdNode.id,
          // };

          // await this.$store.dispatch("createNode", {
          //   chatbotId: this.$route.params.id,
          //   body: childNodeBody,
          // });
          this.handleCreateNode({
            nodeType: childNodeType,
            parentNodeId: createdNode.id,
            previousAction,
          });
        }

        this.$message.success("Se añadio correctamente");
      } catch (error) {
        // const addedNodeText =
        //   nodeType === NodeType.Options ? "las opciones múltiples" : "el mensaje";
        if (previousAction) await updateNode(parentNodeId, { action: previousAction });

        const errorMessage = error?.getErrorMessage?.() || `No se pudo agregar el nodo 😓`;

        this.$message.error(errorMessage);
        console.error(error);
      }

      await this.fetchNodes();
    },
    async fetchNodes() {
      try {
        await this.$store.dispatch("fetchNodes", this.$route.params.id);
        if (this.selectedNodeId) {
          await this.$store.dispatch("fetchNodeDetails", this.selectedNodeId);
        }
      } catch (error) {
        const errorMessage = error?.getErrorMessage() || "Error al cargar los nodos";
        this.$message.error(errorMessage);
        console.log(error);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.text-align-left
  text-align: left

.chatbot-template
  height: 100%

  .description
    color: #51555A
    margin: 12px

  .row-content
    height: 100%

    .gutter-row
      height: 100%
</style>
